import * as Sentry from "@sentry/nextjs";
import { getSentryConfig } from "common/utils/sentry/sentry-config";

Sentry.init(getSentryConfig());

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
